import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
export var Heading = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-17zn0ul-0"
})(["font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.accordion.titleColor;
}, function (props) {
  return props.theme.space(6);
});
export var Container = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-17zn0ul-1"
})(["width:100%;"]);
export var Rows = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-17zn0ul-2"
})(["display:flex;padding:", ";border:1px solid ", ";border-radius:", ";&:not(:last-of-type){margin-bottom:", ";", "}h3{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}p{font-size:", ";line-height:", ";color:", ";}", ""], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.whyRentWithUniplaces.borderColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(5);
}, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n    "]))), function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.whyRentWithUniplaces.titleColor;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(24);
}, function (props) {
  return props.theme.whyRentWithUniplaces.textColor;
}, mediaMin.mediumBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 300px;\n    flex-shrink: 0;\n    flex-direction: column;\n    ", "\n    padding-left: ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(5);
}));
export var Description = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-17zn0ul-3"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.space(2);
});
export var ValueProposition = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-17zn0ul-4"
})(["width:100%;", ""], mediaMin.mediumBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    ", "\n    overflow-x: scroll;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(2);
}));